/**
 * フッターナビ ドロップダウン
 * .js-footer-nav-btn クリックで親 .js-footer-nav-group に is-open トグル
 */
export function init() {
	const groups = document.querySelectorAll('.js-footer-nav-group');
	if (!groups.length) return;

	groups.forEach(function (group) {
		const btn = group.querySelector('.js-footer-nav-btn');
		if (!btn) return;

		btn.addEventListener('click', function () {
			const isOpen = group.classList.contains('is-open');

			// 他のグループを閉じる
			groups.forEach(function (other) {
				if (other !== group) {
					other.classList.remove('is-open');
					const otherBtn = other.querySelector('.js-footer-nav-btn');
					if (otherBtn) otherBtn.setAttribute('aria-expanded', 'false');
				}
			});

			// 自身をトグル
			group.classList.toggle('is-open', !isOpen);
			btn.setAttribute('aria-expanded', String(!isOpen));
		});
	});
}
